import adapter from '../adapter-groups-post';
var IDs = adapter.IDs, SchemaTypes = adapter.SchemaTypes;
export default {
    type: SchemaTypes.GROUPS_POST,
    schema: {
        '@context': 'https://schema.org',
        '@type': 'DiscussionForumPosting',
        author: {
            '@type': 'Person',
            name: "{{" + IDs.POST_AUTHOR + "}}",
            image: {
                '@type': 'ImageObject',
                height: "{{" + IDs.POST_OWNER_IMAGE_HEIGHT + "}}",
                width: "{{" + IDs.POST_OWNER_IMAGE_WIDTH + "}}",
                url: "{{" + IDs.POST_OWNER_IMAGE_URL + "}}",
            },
        },
        articleSection: 'Group name',
        dateModified: '2019-12-15',
        datePublished: '2019-12-15',
        headline: "{{" + IDs.POST_CONTENT_60 + "}}",
        mainEntityOfPage: {
            '@id': "{{" + IDs.POST_URL + "}}",
            '@type': 'itemPage',
        },
        description: "{{" + IDs.POST_CONTENT + "}}",
        url: "{{" + IDs.POST_URL + "}}",
        commentCount: "{{" + IDs.COMMENTS_COUNT + "}}",
        interactionStatistic: {
            interactionType: '{http://schema.org/LikeAction}',
            userInteractionCount: "{{" + IDs.LIKE_COUNT + "}}",
        },
        image: {
            '@type': 'ImageObject',
            height: "{{" + IDs.POST_IMAGE_HEIGHT + "}}",
            width: "{{" + IDs.POST_IMAGE_WIDTH + "}}",
            url: "{{" + IDs.POST_IMAGE_URL + "}}",
        },
        publisher: {
            '@type': 'Organization',
            '@id': "{{" + IDs.POST_PUBLISHER_ID + "}}",
            name: "{{" + IDs.GROUP_NAME + "}}",
            logo: {
                '@type': 'ImageObject',
                url: "{{" + IDs.POST_PUBLISHER_LOGO_URL + "}}",
            },
        },
    },
};
